import { CrudForm } from 'components/form';
import type { Field } from 'components/types';
import { PlanDefinitionFetcher } from 'integration';
import type React from 'react';
import { strings } from 'strings';
import { z } from 'zod';

const CreateAdmissionCarePlanSchema = z.object({
  planDefinition: z.string(),
});
type CreateAdmissionCarePlan = z.infer<typeof CreateAdmissionCarePlanSchema>;

export interface CreateAdmissionCarePlanProps {
  onChange?: (data: CreateAdmissionCarePlan) => void;
}

const createFields = (): Field<CreateAdmissionCarePlan>[] => {
  return [
    {
      subfields: [
        {
          key: 'planDefinition',
          type: 'combobox-single',
          label: strings.AdmissionCarePlanLabel,
          fetcher: PlanDefinitionFetcher,
        },
      ],
    },
  ];
};

export const CreateAdmissionCarePlan: React.FC<
  CreateAdmissionCarePlanProps
> = ({ onChange }) => {
  const fields = createFields();

  return (
    <CrudForm
      fields={fields}
      initialValues={{}}
      showSubmitButton={false}
      onChange={onChange}
      validationSchema={CreateAdmissionCarePlanSchema}
      cardProps={{ unsetZIndex: true }}
      hasCard={false}
      onChangeDebounceTime={0}
    />
  );
};
